import { apiClient } from "api";
import { Dayjs } from "dayjs";
import { TFaxJobSummary } from "./models/types";

export const getFaxJobSummary = async (
  accountId: string,
  faxSummaryDate: Dayjs
): Promise<TFaxJobSummary[]> => {
  const response = await apiClient.get(`faxJobSummary/${accountId}`, {
    params: { summaryDate: faxSummaryDate.format("YYYY-MM-DD") }
  });
  return response.data;
};
